import { IPromise } from 'angular';

import * as Common from '../Common/modules';

export interface IOpportunityApiClient {
  getLatestPropertyRecord: (partnerSystemNumber: string) => ng.IPromise<any>;
}

export class OpportunityApiClient implements IOpportunityApiClient {
  public static $inject = ["igs.apiClientService"];

  constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {}

  public getLatestPropertyRecord = (partnerSystemNumber: string): ng.IPromise<any> => {
    var url = `Opportunities/${partnerSystemNumber}/PropertyRecords/Latest`;
    return this.igsApiClientService.get(url, {
      errorHandler: function (res) {
        if (res.data) {
          console.log(res.data.message);
        }
      },
      nomask: true,
    });
  };
}
